export default __webpack_public_path__ + "static/media/pickup.b713db0e.svg";